export const auth_user_role_tr = {
  MANAGER: "Yönetici",
  DEVELOPER: "Geliştirici",
  DESIGNER: "Tasarımcı",
  VIEWER: "Gözlemci",
};
